import { client } from '../../../services/apiClient';
import type {
  VisibilityReportGenerateRequest,
  VisibilityReportListItem,
  VisibilityReportResponse,
  VisibilityReportShareResponse,
  VisibilityReportsPageResponse,
} from '@brand24-original/llm-types';

const ENDPOINT = '/visibility-report';

export const getVisibilityReports = async (
  projectId: number,
  page: number,
  pageSize: number
): Promise<VisibilityReportsPageResponse> => {
  const { data } = await client(true, true).get<VisibilityReportsPageResponse>(
    `${ENDPOINT}/project/${projectId}`,
    { params: { page, pageSize } }
  );
  return data;
};

export const getVisibilityReport = async (
  reportId: number
): Promise<VisibilityReportResponse> => {
  const { data } = await client(true, true).get<VisibilityReportResponse>(`${ENDPOINT}/${reportId}`);
  return data;
};

export const generateVisibilityReport = async (
  projectId: number,
  body: VisibilityReportGenerateRequest
): Promise<VisibilityReportListItem> => {
  const { data } = await client(true, true).post<VisibilityReportListItem>(
    `${ENDPOINT}/project/${projectId}`,
    body
  );
  return data;
};

export const deleteVisibilityReport = async (reportId: number): Promise<void> => {
  await client(true, true).delete(`${ENDPOINT}/${reportId}`);
};

export const shareVisibilityReport = async (
  reportId: number
): Promise<VisibilityReportShareResponse> => {
  const { data } = await client(true, true).post<VisibilityReportShareResponse>(
    `${ENDPOINT}/${reportId}/share`
  );
  return data;
};

export const unshareVisibilityReport = async (
  reportId: number
): Promise<VisibilityReportShareResponse> => {
  const { data } = await client(true, true).delete<VisibilityReportShareResponse>(
    `${ENDPOINT}/${reportId}/share`
  );
  return data;
};

// `client(true, false)` = bez prefiksu `/api` i bez tokena — podgląd z linku jest publiczny.
export const getSharedVisibilityReport = async (
  shareToken: string
): Promise<VisibilityReportResponse> => {
  const { data } = await client(true, false).get<VisibilityReportResponse>(
    `/shared-report/${shareToken}`
  );
  return data;
};

/** The report PDF, rendered by the backend from the stored snapshot (`lang` picks the texts). */
export const downloadVisibilityReportPdf = async (
  reportId: number,
  lang: 'en' | 'pl'
): Promise<Blob> => {
  const { data } = await client(true, true).get<Blob>(`${ENDPOINT}/${reportId}/pdf`, {
    params: { lang },
    responseType: 'blob',
  });
  return data;
};

/** The same PDF for a link holder — public, like `getSharedVisibilityReport`. */
export const downloadSharedVisibilityReportPdf = async (
  shareToken: string,
  lang: 'en' | 'pl'
): Promise<Blob> => {
  const { data } = await client(true, false).get<Blob>(`/shared-report/${shareToken}/pdf`, {
    params: { lang },
    responseType: 'blob',
  });
  return data;
};
